import { useIntl } from 'react-intl'

import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import MultiRoomModeToggle from 'components/OfferPage/MultipleRoomsBooking/MultiRoomModeToggle'
import Group from 'components/utils/Group'
import type {
  OfferPageRoom,
  OfferPageState,
} from 'contexts/OfferPage/offerPageStateReducer'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import { preventRenderWithOpenFilter } from 'lib/offer/offerPageUtil'
import { getPropertyCombinedRatesByRoom } from 'selectors/offerPage/offerPageSelectors'

interface Props {
  rooms: Array<OfferPageRoom>
  hasBookableRooms: boolean
}

/** Tablet+ multi-room heading + toggle block. */
function PropertyMultiRoomBookingSectionDesktopView(props: Props) {
  const {
    rooms,
    hasBookableRooms,
  } = props

  const intl = useIntl()

  if (!hasBookableRooms) {
    return null
  }

  return (
    <VerticalSpacer gap={16}>
      <Group direction="horizontal" horizontalAlign="space-between" verticalAlign="start" gap={16}>
        <div>
          <Heading variant="heading3" as="h2">
            {intl.formatMessage(
              {
                id: 'VCDugTs-8l9la-tEywnD',
                defaultMessage: 'Select your {count, plural, one {room} other {# rooms}}',
                description: 'Heading for selecting room packages on the hotel or room booking page',
              },
              { count: rooms.length },
            )}
          </Heading>
          <BodyText variant="medium">
            {intl.formatMessage({
              id: 'fl1Ytt4-aiddKRGd_IO2',
              defaultMessage: 'Choose the same package for all rooms, or customise each room individually.',
              description: 'Description for multi-room booking options in the booking flow',
            })}
          </BodyText>
        </div>
      </Group>
      <Group direction="horizontal">
        <MultiRoomModeToggle inputsName="room-mode-spp-desktop" />
      </Group>
    </VerticalSpacer>
  )
}

type MappedProps = Pick<Props,
  | 'rooms'
  | 'hasBookableRooms'
> & { open?: boolean }

function mapState(state: OfferPageState, appState: App.State): MappedProps {
  return {
    rooms: state.rooms,
    hasBookableRooms: getPropertyCombinedRatesByRoom(state, appState).length > 0,
    open: !!state.activeFilter,
  }
}

export const PropertyMultiRoomBookingSectionDesktop = withOfferPageAndReduxState(
  mapState,
  PropertyMultiRoomBookingSectionDesktopView,
  preventRenderWithOpenFilter,
)
